module.exports = __webpack_public_path__ + "img/shady10.9232bb96.jpg";